import FunctionListPage from "./function-list-page.jsx";

export default FunctionListPage;